import { render, staticRenderFns } from "./KTreeView.vue?vue&type=template&id=4ea6962b&scoped=true&"
import script from "./KTreeView.vue?vue&type=script&lang=js&"
export * from "./KTreeView.vue?vue&type=script&lang=js&"
import style0 from "./KTreeView.vue?vue&type=style&index=0&id=4ea6962b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6962b",
  null
  
)

export default component.exports